import { Subject } from "rxjs";

export const handleChange = new Subject();